import { useLocation } from "@tanstack/react-router";
import { useMemo } from "react";
import { PLATFORMS } from "@/types/platform.types";
import { useUserRoles } from "@/lib/keycloak";
import { getAvailablePlatformsForRoles } from "@/hooks/use-platform/platform-access";

export function usePlatform() {
	const { pathname } = useLocation();
	const { roles } = useUserRoles();

	const platform = useMemo(
		() => Object.values(PLATFORMS).find((p) => pathname.startsWith(`/${p}`)),
		[pathname]
	);

	const availablePlatforms = useMemo(
		() => getAvailablePlatformsForRoles(roles),
		[roles]
	);

	return {
		platform,
		availablePlatforms,
		isDriverPlatform: platform === PLATFORMS.DRIVER,
		isFleetPlatform: platform === PLATFORMS.FLEET,
		isAdminPlatform: platform === PLATFORMS.ADMIN,
		noAvailablePlatforms: availablePlatforms.length === 0,
	};
}
